.issueStatus {
	display: flex;
	padding: 0 var(--jpo-common-base-spacing);
	min-height: 40px;
	/* positioning the status lozenge at the center of its container cell */
	& > * {
		align-self: center;
	}
}
